import { h, Component } from 'preact';
import s from 'components/bolt/forms/recaptcha/recaptcha.sss';

/**
 * Documentation: https://www.google.com/recaptcha/about/
 * Create New: https://www.google.com/recaptcha/admin/create
 * Notes:
 * 	- localhost can be whitelisted as 'Localhost' inside Domains, then we should also whitelist demo like 'demo.pow.io' and the production vanity url
 * 	- 'v2-tickbox' type refers to Google reCAPTCHA v2 - 'I'm not a robot' tickbox
 */

export default class Recaptcha extends Component {
	constructor(props) {
		super(props);
		this.loadScript = this.loadScript.bind(this);
		this.renderGrecaptcha = this.renderGrecaptcha.bind(this);
		this.isReady = this.isReady.bind(this);
		this.reset = this.reset.bind(this);

		this.state = {
			ready: this.isReady(),
			widget: null,
		};
		this.readyCheck = null;

		if (!this.state.ready && typeof window !== 'undefined') {
			this.readyCheck = setInterval(this.updateReadyState.bind(this), 1000);
		}
	}

	componentDidMount() {
		this.loadScript('https://www.google.com/recaptcha/api.js', 'reCaptcha');

		if (this.state.ready) {
			this.renderGrecaptcha();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { onLoad } = this.props;
		if (onLoad && this.state.ready && !prevState.ready) {
			this.renderGrecaptcha();
		}
	}

	componentWillUnmount() {
		clearInterval(this.readyCheck);
		this.$captcha?.remove();
		this.props.onUnmount();
	}

	loadScript(url, id) {
		return new Promise((resolve, reject) => {
			let script = document.createElement('script');
			script.onload = resolve;
			script.onerror = reject;
			script.src = url;
			script.id = id;
			document.body.appendChild(script);
		});
	}

	renderGrecaptcha() {
		this.state.widget = window.grecaptcha.render(this.$captcha, {
			sitekey: this.props.siteKey,
			callback: (this.props.onSuccess) ? this.props.onSuccess : undefined,
			theme: this.props.theme,
			type: this.props.type,
			size: this.props.size,
			tabindex: this.props.tabindex,
			hl: this.props.hl,
			badge: this.props.badge,
			'expired-callback': (this.props.onFailed) ? this.props.onFailed : undefined,
		});

		if (this.props.onLoad) {
			this.props.onLoad();
		}
	}

	updateReadyState() {
		if (this.isReady()) {
			this.setState({ ready: true });
			clearInterval(this.readyCheck);
		}
	}

	isReady() {
		return (
			typeof window !== 'undefined' &&
			typeof window.grecaptcha !== 'undefined' &&
			typeof window.grecaptcha.render === 'function'
		);
	}

	reset() {
		const { ready, widget } = this.state;
		if (ready && widget !== null) {
			window.grecaptcha.reset(widget);
		}
	}


	render(props) {
		const { type } = props;

		if (!this.state.ready) {
			return 	(
				<div className={s.wrapper}>
					<div className={s.loader}>reCAPTCHA</div>
				</div>
			);
		}

		if (type === 'v2-tickbox') {
			return (
				<div className={s.wrapper}>
					<div ref={e => this.$captcha = e} />
					<div className={s.notesText}>
						<div>reCAPTCHA helps prevent automated form spam. </div>
						<div>The submit button will be disabled until you complete the CAPTCHA.</div>
					</div>
				</div>
			);
		}
	}
}
